export default __webpack_public_path__ + "static/media/b32.0bf8a854.png";